import styled from "styled-components";

export const FooterContainer = styled.div`
    width: 100%;
    height: 80px;

    margin-top: auto;

    box-sizing: border-box;
    padding: 12px;

    display: flex;
    justify-content: flex-end;
    align-items: center;

    background-color: black;
    color: white;
`;
